/*=====================================
    BonusProductListItemView

    Author: Ac
    createtime: 2018 / 10 / 01
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from "react";
import PropTypes from 'prop-types';
import { TileStyle } from 'stylecomponents';
import CupoyImage from 'components/commons/CupoyImage';

/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
const tileStyle = {
  tileWidth: 240,
  tileHeight: 264,
};
/*--------------------------
    Style Component
--------------------------*/
const Container = TileStyle.Container.extend`
  display: inline-block;
  margin-right: ${({ needMarginRight }) => needMarginRight ? `20px` : 0};
  margin-bottom: 20px;
`;
const Image = TileStyle.TileImg.extend`
  width: 238px;
  height: 176px;
`;

/*--------------------------
    Main Component
--------------------------*/
class BonusProductListItemView extends PureComponent {

  static propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    imageSrc: PropTypes.string,
    isHot: PropTypes.bool,
    needMarginRight: PropTypes.bool,
    routeToContent: PropTypes.func,
    buyBonus: PropTypes.func,
  };

  routeToContent = () => {
    const { id } = this.props;
    this.props.routeToContent(id);
  }

  buyBonus = event => {
    const { id } = this.props;
    this.props.buyBonus(id, event);
  }

  render() {

    const {
      name,
      imageSrc,
      isHot,
      needMarginRight,
  } = this.props;

    return (
      <Container
        width={tileStyle.tileWidth}
        height={tileStyle.tileHeight}
        needMarginRight={needMarginRight}
        onClick={this.routeToContent}
      >
        <CupoyImage
          isBackgroundImage
          src={imageSrc}
          stylecomponent={Image}
        />
        {isHot && <TileStyle.HotTag>HOT</TileStyle.HotTag>}
        <TileStyle.TextWrapper column paddingTop>
        <TileStyle.Text bold>{name}</TileStyle.Text>
        <TileStyle.ClickButton onClick={this.buyBonus}>
          立即兌換
        </TileStyle.ClickButton>
        </TileStyle.TextWrapper>
      </Container>
    );
  }
}

export default BonusProductListItemView;